import React from "react";
import ContactUsHolBannerSrc from "../assets/img/hol/Contact-us-Banner-2560x600.jpg";
import ContactUsHolBannerSrcMobile from "../assets/img/hol/Contact-us-Banner-640x300.jpg";
import { Paths, Urls } from "../constants/UrlConstants";
import { Link } from "react-router-dom";
import {
  getPhone,
  getOpeningHours,
  getPhoneTechnical,
  getOpeningHoursTechnical,
  getPhoneClaims,
  getOpeningHoursClaims
} from "../helpers/ContentStateHelper";
import { getContent } from "./Content";
import style from "../assets/css/modules/contact-us/contact-us.css";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import { RebrandHelper } from "../helpers/brand/RebrandHelper";

const memberOnlineHeading = "Member Online";
const customerOnlineHeading = "Customer Online";

const get24hoursNumber = (state) =>
  getContent(state, {
    Lapsed: null,
    Any: {
      heading: "24 hour medical help",
      phoneNumber: "0800 003 004",
      openingHours: "Talk to a medical professional at any time, day or night."
    }
  });

  const getLeavingScheme = (state)=>
    getContent(state,{
      Lapsed: null,
      Any: {
        heading: "Leaving your company scheme",
        phoneNumber: "0800 707 6804",
        openingHours: "8am-7pm, Monday-Friday"
      }
    });

const ContactUs = {
  HeroContent: {
    Heading: "Contact us",
    Header: "Online",
    ContactUsBannerSrc: {
      Any: null, // Use background color instead
      HOL: ContactUsHolBannerSrc
    },
    ContactUsBannerSrcMobile: {
      Any: null, // Use background color instead
      HOL: ContactUsHolBannerSrcMobile
    },
    Description: (
      <React.Fragment>
        <p>
          If you've a query or would like to speak to us, just get in touch
          using one of the links below.
        </p>
      </React.Fragment>
    ),
    HowCanWeHelp: (
      <p>
        <strong>How can we help you?</strong>
      </p>
    ),
    ProfileInfo: (
      <p>
        To update your contact details, please go to your{" "}
        <Link
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          to={Paths.MyProfile}
        >
          profile
        </Link>
        .
      </p>
    )
  },
  PhoneHeader: "Call us",
  PhoneDisclaimer:
    "We may record and/or monitor calls for quality assurance, training and as a record of our conversation.",
  TravelOrEAP: (state) => [
    {
      heading: getContent(state, {
        HOL: customerOnlineHeading,
        Any: memberOnlineHeading
      }),
      phoneNumber: getPhoneTechnical(state),
      openingHours: getOpeningHoursTechnical(state)
    },
    get24hoursNumber(state)
  ],
  PhoneNumbers: {
    International: (state) => [
      {
        heading: "Your plan / claims",
        phoneNumber: getPhone(state),
        openingHours: getOpeningHours(state)
      },
      {
        heading: "Your online account",
        phoneNumber: "+44 1892 596432",
        openingHours: "24 hours a day, 365 days a year."
      },
      {
        heading: "24 hour medical help",
        phoneNumber: "0800 003 004",
        comment: "",
        openingHours: (
          <React.Fragment>
            (UK and Channel Islands)
            <br />
            <span className={style.phoneNumber}>+44 1892 772578</span>
            <br />
            24 hours a day, 365 days a year.
          </React.Fragment>
        )
      }
    ],
    Saga: (state) => [
      {
        heading: "Your policy",
        phoneNumber: "0800 056 9273",
        openingHours: (
          <React.Fragment>
            8.30am-7pm, Monday - Friday;
            <br />
            9am-1pm, Saturday;
            <br />
            10am-2pm, Sunday
          </React.Fragment>
        )
      },
      {
        heading: "Claims",
        phoneNumber: getPhone(state),
        openingHours: getOpeningHours(state)
      },
      {
        heading: memberOnlineHeading,
        phoneNumber: getPhoneTechnical(state),
        openingHours: (
          <React.Fragment>
            8am-8pm, Monday - Friday;
            <br />
            9am-5pm, Saturday
          </React.Fragment>
        )
      },
      get24hoursNumber(state)
    ],
    Format2: (state) => [ //Indivitual
      {
        heading: "Your plan / claims",
        phoneNumber: getPhone(state),
        openingHours: getOpeningHours(state)
      },
      {
        heading: memberOnlineHeading,
        phoneNumber: getPhoneTechnical(state),
        openingHours: getOpeningHoursTechnical(state)
      },
      get24hoursNumber(state)
    ],
    Format2SMEandLargeCorporate: (state) => [ // large corporate
      {
        heading: "Your plan / claims",
        phoneNumber: getPhone(state),
        openingHours: getOpeningHours(state)
      },
      {
        heading: memberOnlineHeading,
        phoneNumber: getPhoneTechnical(state),
        openingHours: getOpeningHoursTechnical(state)
      },
      get24hoursNumber(state),
      getLeavingScheme(state)
    ],
    SMEModular: (state) => [ //SMEModular
      {
        heading: "Claims",
        phoneNumber: getPhoneClaims(state),
        openingHours: getOpeningHoursClaims(state)
      },
      {
        heading: getContent(state, {
          HOL: customerOnlineHeading,
          Any: memberOnlineHeading
        }),
        phoneNumber: getPhoneTechnical(state),
        openingHours: getOpeningHoursTechnical(state)
      },
      get24hoursNumber(state),
      getLeavingScheme(state)
    ],
    SMEonly: (state) => [ //SME
      {
        heading: getContent(state, { HOL: "Your policy", Any: "Your plan" }),
        phoneNumber: getPhone(state),
        openingHours: getOpeningHours(state)
      },
      {
        heading: "Claims",
        phoneNumber: getPhoneClaims(state),
        openingHours: getOpeningHoursClaims(state)
      },
      {
        heading: getContent(state, {
          HOL: customerOnlineHeading,
          Any: memberOnlineHeading
        }),
        phoneNumber: getPhoneTechnical(state),
        openingHours: getOpeningHoursTechnical(state)
      },
      get24hoursNumber(state),
      getLeavingScheme(state)
    ],    
    Any: (state) => [ //Indivitual
      {
        heading: getContent(state, { HOL: "Your policy", Any: "Your plan" }),
        phoneNumber: getPhone(state),
        openingHours: getOpeningHours(state)
      },
      {
        heading: "Claims",
        phoneNumber: getPhoneClaims(state),
        openingHours: getOpeningHoursClaims(state)
      },
      {
        heading: getContent(state, {
          HOL: customerOnlineHeading,
          Any: memberOnlineHeading
        }),
        phoneNumber: getPhoneTechnical(state),
        openingHours: getOpeningHoursTechnical(state)
      },
      get24hoursNumber(state)
    ]
  },
  PostHeader: { Saga: "Write to us about your policy", Any: "Write to us" },
  PostAddress: {
    International: [
      "Customer Service, AXA Global Healthcare (UK) Limited",
      "International House, Forest Road",
      "Tunbridge Wells, Kent",
      "TN2 5FE, UK"
    ],
    Saga: [
      "Saga Services Limited",
      "3 Pancras Square",
      "London",
      "N1C 4AG"
    ],
    HOL: [
      "Health-on-Line",
      "80 Holdenhurst Road",
      "Bournemouth, Dorset",
      "BH8 8AQ, United Kingdom"
    ],
    Any: [
      RebrandHelper.getAxaBrandName(),
      "International House, Forest Road,",
      "Tunbridge Wells,",
      "Kent, TN2 5FE"
    ]
  },
  PostHeader2: { Saga: "Write to us about your claims", Any: null },
  PostAddress2: {
    Saga: [
      RebrandHelper.getAxaBrandName(),
      "International House, Forest Road,",
      "Tunbridge Wells,",
      "Kent, TN2 5FE"
    ],
    Any: []
  },
  travelHeading: "Travel",
  travelDescription: (
    <React.Fragment>
      <p>
        If you'd like to discuss any of the benefits on your Travel policy,
        please contact our Travel Team on <strong>01892 504 444</strong> or if
        you'd like to discuss a claim, please contact our Travel Claims helpline
        on <strong>0345 602 0303</strong>.
      </p>
    </React.Fragment>
  ),
  eapHeading: "Employee Assistance Programme",
  eapDescription: (
    <React.Fragment>
      <p>
        If you'd like to speak to someone confidentially about financial
        concerns or family worries, please contact us on{" "}
        <strong>0800 138 5472</strong> or to find out more, go to{" "}
        <a
          className={layoutStyle.anchorDecorationUnderline}
          href={Urls.AXABeSupportedURL}
          rel="noopener noreferrer"
          target="_blank"
        >
          Be supported
        </a>{" "}
        and enter the username <strong>business</strong> and password{" "}
        <strong>supported</strong>.
      </p>
    </React.Fragment>
  ),
  LeaverHeader: "Leaving your company healthcare scheme?",
  LeaverDescription: (
    <React.Fragment>
      <p><strong>Your healthcare cover options when you leave employment</strong> </p>

      <ul className={style.ticklist}>
        <li>Whether you’re changing jobs, retiring, taking redundancy</li>
        <li>You could stay covered for previous and existing medical conditions</li>
        <li>Keep family members on your healthcare plan</li>
        <li>Taking out your personal healthcare cover is quick and easy – no forms to fill or medical examination needed when you join</li>
      </ul>

    </React.Fragment>
  ),
  LeaverDescription1: (
    <React.Fragment>
      <p>
        If you or any family member previously covered on the company scheme have a pre-existing condition, we could still cover you for that condition as long as it’s covered under the benefits of the new plan you choose. (Please note, any terms applied on your company scheme will also apply to your new personal plan.)</p>
      <p>Special offer is only valid for 120 days after your company scheme membership ends. Call us as soon as you know you are leaving, so your new personal plan is ready to start straightaway, ideally on the day your company cover ends, to ensure cover is in place for whenever you might need it.</p>
      <p>Individual healthcare plans are underwritten by AXA PPP healthcare Limited </p>
      <p>Lines are open 8am – 7pm Monday-Friday</p>
        <p>We may record and monitor calls for quality assurance, training and as a record of our conversation.
       </p>
    </React.Fragment>
  ),
  CallusOn: (
    <React.Fragment>
  <a href="tel:0800 032 1965"> Call us on 0800 707 6804 </a>
    </React.Fragment>
  ),

  RequestCallBack : "Request a call back ",
  LapsedLeaverHeader:(
    <React.Fragment>
    <h2>Stay with us now you’ve left your company healthcare scheme</h2>
    </React.Fragment>
  ),
  LapsedLeaverDescription: (
    <React.Fragment>
      <ul className={style.ticklist}>
        <li>Whether you’re changing jobs, retiring, taking redundancy</li>
        <li>Stay covered for previous and existing medical conditions</li>
        <li>Keep family members on your health insurance plan</li>
        <li>Taking out personal health cover is quick and easy - even if you’re new to AXA Health or leaving a Trust scheme</li>
      </ul>

    </React.Fragment>
  ),
};

export default ContactUs;
